export const Parser = {
  getDataByURL: async (urlStats) => {
    const url = encodeURIComponent(urlStats);
    const proxyUrl = `/.netlify/functions/proxy?url=${url}`;
    const response = await fetch(proxyUrl);
    const htmlText = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlText, "text/html");
    if (urlStats.includes("feb.es")) {
      return Parser.getFromFEB(doc);
    } else if (urlStats.includes("proballers.com")) {
      const urlTotals = urlStats + "/totals"
      const proxyUrlTotals = `/.netlify/functions/proxy?url=${encodeURIComponent(urlTotals)}`;
      const responseTotals = await fetch(proxyUrlTotals);
      const htmlTextTotals = await responseTotals.text();
      const docTotals = parser.parseFromString(htmlTextTotals, "text/html");
      return Parser.getFromProballers(doc, docTotals);
    }
    return {}; 
  },

  getFromFEB: (doc) => {
    const player = {}
    const wrapper = doc.querySelector(".wrapper-seccion-contents");
    if (!wrapper) console.error("No se encontró el div .wrapper-seccion-contents");
    const linkImg = wrapper.querySelector(".foto img");
    if (linkImg) {
      player.urlPhoto = linkImg.getAttribute("src");
    }
    const tableCareer = wrapper.querySelector("#_ctl0_MainContentPlaceHolderMaster_trayectoriaDataGrid");
    if (tableCareer) {
        const lastTr = tableCareer.querySelector("tr:last-child");
        if (lastTr) { 
          const tdCategory = lastTr.querySelectorAll("td")[1];
          if (tdCategory) {
            player.categoryLastTeam = Parser.parseCategory(tdCategory.textContent.trim());
            player.countryLastTeam = "España"
          }
        }
      }

      const divNodosInfo = wrapper.querySelectorAll(".info .nodo");
      if (divNodosInfo) {
        const position = divNodosInfo[2].querySelector(".string")
        if (position) {
          player.position = Parser.parsePosition(position.textContent.trim());
        }
        const height = divNodosInfo[3].querySelector(".string")
        if (height) {
          const heightNumber = height.textContent.trim().replace(" cm", "")
          if (heightNumber && !isNaN(heightNumber)) {
            player.height = (heightNumber/100).toFixed(2); 
          }
        }
        const birthDate = divNodosInfo[5].querySelector(".string")
        if (birthDate) {
          player.birthDate = birthDate.textContent.trim().split(" ")[0]
        }
        const nationality = divNodosInfo[6].querySelector(".string")
        if (nationality) {
          player.nationality = nationality.textContent.trim().split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
        }
      }
      const tables = wrapper.querySelectorAll("table");
      if (tables.length < 3) console.error("No hay suficientes tablas");
      const thirdTable = tables[2];
      const tr = thirdTable.querySelector("tr.row-total");
      const tdPartidos = tr.querySelector("td.partidos");
      if (!tdPartidos) console.error("No se encontró <td class='partidos'>");
      const tdMinutes = tr.querySelector("td.minutos");
      if (!tdMinutes) console.error("No se encontró <td class='minutos'>");
      const tdPoints = tr.querySelector("td.puntos");
      if (!tdPoints) console.error("No se encontró <td class='puntos'>");
      const tdRebounds = tr.querySelectorAll("td.rebotes.total");
      if (!tdRebounds) console.error("No se encontró <td class='rebotes total'>");
      const tdAssists = tr.querySelector("td.asistencias");
      if (!tdAssists) console.error("No se encontró <td class='asistencias'>");
      const tdSteals = tr.querySelector("td.recuperaciones");
      if (!tdSteals) console.error("No se encontró <td class='recuperaciones'>");
      const tdTurnovers = tr.querySelector("td.perdidas");
      if (!tdTurnovers) console.error("No se encontró <td class='perdidas'>");
      const tdBlocks = tr.querySelectorAll("td.tapones.favor");
      if (!tdBlocks) console.error("No se encontró <td class='tapones favor'>");
      const tdFg2 = tr.querySelectorAll("td.tiros.dos");
      if (!tdFg2) console.error("No se encontró <td class='tiros dos'>");
      const fg2 = tdFg2[0].textContent.trim().split("/");
      if (fg2.length !== 2) console.error("Formato de tiros de dos incorrecto");
      const tdFg3 = tr.querySelectorAll("td.tiros.tres");
      if (!tdFg3) console.error("No se encontró <td class='tiros tres'>");
      const fg3 = tdFg3[0].textContent.trim().split("/");
      if (fg3.length !== 2) console.error("Formato de tiros de tres incorrecto");
      const tdFtm = tr.querySelectorAll("td.tiros.libres");
      if (!tdFtm) console.error("No se encontró <td class='tiros libres'>");
      const ftm = tdFtm[0].textContent.trim().split("/");
      if (ftm.length !== 2) console.error("Formato de tiros libres incorrecto");
      
      
      player.numMatches = tdPartidos.textContent.trim();
      player.minutes = tdMinutes.textContent.trim();
      player.points = tdPoints.textContent.trim();
      player.rebounds = tdRebounds[0].textContent.trim();
      player.assists = tdAssists.textContent.trim();
      player.steals = tdSteals.textContent.trim();
      player.turnovers = tdTurnovers.textContent.trim();
      player.blocks = tdBlocks[0].textContent.trim();
      player.fg2m = fg2[0].trim();
      player.fg2a = fg2[1].trim();
      player.fg3m = fg3[0].trim();
      player.fg3a = fg3[1].trim();
      player.ftm = ftm[0].trim();
      player.fta = ftm[1].trim();
      console.log({player})
      return player
  },

  getFromProballers: (doc, docTotals) => {
    const player = {}
    const linkImg = doc.querySelector(".identity__picture__box img")
    if (linkImg) {
      player.urlPhoto = linkImg.getAttribute("src");
    }
    const profile = doc.querySelectorAll(".identity__stats__profil div");
    if (profile.length > 0) {
      const dateStr = profile[0].querySelector(".info").textContent.trim()
      player.birthDate = Parser.parseDateProballers(dateStr);
      const heightStr = profile[1].querySelector(".info").textContent.trim()
      const heightParts = heightStr.split("/")
      if (heightParts.length === 2) {
        const heightNumber = heightParts[0].trim().replace("m",""); 
        player.height = (heightNumber/100).toFixed(2);
      } else {
        console.error("Formato de altura incorrecto:", heightStr);
      }
    }

    const firstname = doc.querySelector(".identity__name .firstname").textContent.trim();
    const lastname = doc.querySelector(".identity__name .lastname").textContent.trim();
    player.name = `${firstname} ${lastname}`;
  
    const tableCareer = docTotals.querySelector("#stats .table");
    const trs = tableCareer.querySelectorAll("tr");
    if (trs.length > 0) {
      const lastTr = trs[trs.length - 1];
      const tds = lastTr.querySelectorAll("td");
      if (tds.length > 1) {
        const season = tds[0].querySelector("a").textContent.trim();
        if (season === "24-25"){
          player.lastTeam = tds[1].querySelector("a").textContent.trim();
          player.points = tds[3].textContent.trim();
          player.rebounds = tds[4].textContent.trim();
          player.assists = tds[5].textContent.trim();
          player.numMatches = tds[6].textContent.trim();
          player.minutes = tds[8].textContent.trim()+":00";
          const fg2 = tds[9].textContent.trim().split("/");
          if (fg2.length !== 2) console.error("Formato de tiros de dos incorrecto");
          const fg3 = tds[10].textContent.trim().split("/");
          if (fg3.length !== 2) console.error("Formato de tiros de tres incorrecto");
          const ftm = tds[12].textContent.trim().split("/");
          if (ftm.length !== 2) console.error("Formato de tiros libres incorrecto");
          player.fg2m = fg2[0].trim();
          player.fg2a = fg2[1].trim();
          player.fg3m = fg3[0].trim();
          player.fg3a = fg3[1].trim();
          player.ftm = ftm[0].trim();
          player.fta = ftm[1].trim();
          player.steals = tds[17].textContent.trim();
          player.turnovers = tds[18].textContent.trim();
          player.blocks = tds[19].textContent.trim();
        }
      }
    }
    return player
  },

  parseCategory: (category) => {
    return category.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
  },

  parsePosition: (position) => {
    const positionArray = ['','Base', 'Escolta', 'Alero', 'A-Pívot', 'Pívot'];
    return positionArray.findIndex(pos => pos.toLowerCase() === position.toLowerCase()) || position;
  },

  parseDateProballers: (dateStr) => {
    let day, month, year;
    const dateParts = dateStr.split(',');
    if (dateParts.length > 2) {
      console.error("Formato de fecha incorrecto:", dateStr);
      return '';
    }
    if (dateParts.length === 1) {
      const dayMonthYear = dateParts[0].trim().split(' ');
      if (dayMonthYear.length !== 3) {
        console.error("Formato de fecha incorrecto:", dateStr);
        return '';
      }
      day = parseInt(dayMonthYear[0]);
      month = dayMonthYear[1].toLowerCase();
      year = parseInt(dayMonthYear[2]);
    } else {
      const dayMonth = dateParts[0].trim().split(' ');
      if (dayMonth.length !== 2) {
        console.error("Formato de fecha incorrecto:", dateStr);
        return '';
      }
      day = parseInt(dayMonth[1]);
      month = dayMonth[0].toLowerCase();
      year = parseInt(dateParts[1].trim())

    }


    
    
    const monthMap = {
      "jan": 0, "feb": 1, "mar": 2, "apr": 3,
      "may": 4, "jun": 5, "jul": 6, "aug": 7,
      "sep": 8, "oct": 9, "nov": 10, "dec": 11
    };
    
    if (!(month in monthMap)) {
      console.error("Mes no reconocido:", month);
      return '';
    }
    
    const monthIndex = monthMap[month];
    return `${day.toString().padStart(2, '0')}/${(monthIndex + 1).toString().padStart(2, '0')}/${year}`;
  }

}
